import React from 'react';
import { Link } from 'gatsby';

import { createUseStyles, useTheme } from "react-jss";

const interactionStyles = {
  '&:hover': {
    transform: 'translateY(-.2rem)'
  },
  '&:active': {
    transform: 'translateY(.1rem)'
  }
};

const useStyles = createUseStyles(theme => ({
  button: {
    borderRadius: '5px',
    color: theme.colors.white,
    fontWeight: 'bold',
    display: 'inline-block',
    fontSize: '1.4rem',
    border: 'none',
    cursor: 'pointer',
    textAlign: 'center',
    transition: 'all 0.25s ease-in-out',
    '&:hover': {
      opacity: 1
    }
  },
  default: {
    padding: '1.2rem 2.75rem'
  },
  large: {
    padding: '2rem 0',
    width: '23rem',
    [`@media (max-width: ${theme.breakpoints.small})`]: {
      width: '100%',
      maxWidth: `100%`
    }
  },
  wide: {
    padding: '1.75rem',
    width: '23rem'
  },
  primary: {
    extend: interactionStyles
  },
  secondary: {
    extend: interactionStyles
  },
  contained: {
    '&$primary': {
      background: theme.colors.teal.main,
      '&:hover': {
        background: theme.colors.teal.light
      },
      '&:active': {
        background: theme.colors.teal.main
      }
    },
    '&$secondary': {
      background: theme.colors.orange.main,
      '&:hover': {
        background: theme.colors.orange.light
      },
      '&:active': {
        background: theme.colors.orange.main
      }
    }
  },
  text: {
    '&$primary': {
      color: theme.colors.teal.main,
      border: '1px solid transparent',
      background: theme.colors.teal.washed,
      '&:hover': {
        background: theme.colors.white,
        borderColor: theme.colors.teal.main
      },
      '&:active': {
        background: theme.colors.teal.washed
      }
    }
  },
  styleless: {
    background: 'none',
    border: 'none',
    lineHeight: '1',
    padding: '2px',
  },
}));

const Button = ({ useLink, btnSize, btnColor, variant, children, className, href, ...rest }) => {
  const theme = useTheme();
  const styles = useStyles({ theme });

  const classes = `${styles.button} ${styles[btnColor]} ${styles[btnSize]} ${styles[variant]} ${className}`;

  if (href) {
    if (useLink) {
      return <Link className={classes} to={href} {...rest}>{children}</Link>
    } else {
      return <a className={classes} href={href} {...rest}>{children}</a>
    }
  } else {
    return (
      <button className={classes} {...rest}>{children}</button>
    )
  }
}

Button.defaultProps = {
  btnSize: 'default',
  btnColor: 'primary',
  variant: 'contained',
  className: '',
  useLink: false
}

export default Button;